import { Component } from '@theme/component';
import { onAnimationEnd, isClickedOutside } from '@theme/utilities';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} panel
 *
 * @extends Component<Refs>
 */
class CartActionsPopover extends Component {
  requiredRefs = ['panel'];

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('keydown', this.#handleKeyDown);
  }

  open = () => {
    if (this.hasAttribute('open')) return;

    this.setAttribute('open', '');
    this.addEventListener('click', this.#handleClick);
    this.addEventListener('keydown', this.#handleKeyDown);
  };

  close = async () => {
    if (!this.hasAttribute('open')) return;

    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('keydown', this.#handleKeyDown);

    this.refs.panel.classList.add('cart-actions-popover__panel--closing');
    await onAnimationEnd(this.refs.panel, undefined, { subtree: false });
    this.refs.panel.classList.remove('cart-actions-popover__panel--closing');

    this.removeAttribute('open');
  };

  /**
   * @param {MouseEvent} event
   */
  #handleClick = (event) => {
    if (isClickedOutside(event, this.refs.panel)) this.close();
  };

  /**
   * @param {KeyboardEvent} event
   */
  #handleKeyDown = (event) => {
    if (event.key !== 'Escape') return;

    event.preventDefault();
    this.close();
  };
}

if (!customElements.get('cart-actions-popover')) {
  customElements.define('cart-actions-popover', CartActionsPopover);
}
